<template>
  <div>
    <TippCard
      hintID="Mitgliederverwaltung_Fristenüberwachung_1_V1"
      text="Mittels Fristen werden Ablaufdaten definiert, die für Personen gezielt überwacht werden können. Mit konfigurierbaren Schwellen können Zähler nach eigenen Wünschen konfiguriert werden."
    >
    </TippCard>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="start">
            <v-col cols="12" sm="12" md="5">
              <Subheader
                icon="mdi-binoculars"
                title="Überwachte Fristen"
                :actions="actions"
              >
              </Subheader>
              <div class="mt-7">
                <v-data-iterator
                  :items="deadlines"
                  item-key="meta.id"
                  sort-by="sortKey"
                  :sort-desc="false"
                >
                  <template v-slot:default="props">
                    <v-row>
                      <v-col
                        v-for="item in props.items"
                        :key="item.meta.id"
                        cols="12"
                      >
                        <deadline-detail-counter-card
                          :deadline="item"
                          link
                        ></deadline-detail-counter-card>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-iterator>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="7">
              <Subheader
                icon="mdi-timer-sand-complete"
                title="Bevorstehende Ablaufdaten (6 Wochen)"
              >
              </Subheader>
              <div class="mt-7">
                <v-skeleton-loader
                  v-if="dataIsLoading"
                  elevation="2"
                  type="card-heading, table"
                ></v-skeleton-loader>
                <v-card v-else>
                  <personnel-record-deadlines-data-table
                    hideTitle
                    :deadlines="upcomingDueDates"
                    showNames
                    showDeadline
                    allowGrouping
                    allowGroupingByDeadline
                    allowGroupingByPerson
                    allowGroupingByStatus
                  ></personnel-record-deadlines-data-table>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
    <router-view />
  </div>
</template>

<script>
import { db, Timestamp } from "@/firebase";
import Subheader from "@/components/_systemwide/Subheader.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import DeadlineDetailCounterCard from "@/components/member-management/deadlines/DeadlineDetailCounterCard.vue";
import PersonnelRecordDeadlinesDataTable from "@/components/member-management/personnel-records/PersonnelRecordDeadlinesDataTable.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_DEADLINES } from "@/store/action-types.js";
import { MEMBER_MANAGEMENT_DEADLINES_create } from "@/data/permission-types.js";

export default {
  name: "member-management-deadline-monitoring-tab-overview",
  components: {
    Subheader,
    SupportTools,
    DeadlineDetailCounterCard,
    PersonnelRecordDeadlinesDataTable,
    TippCard,
  },
  data() {
    return {
      dataIsLoading: false,
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus",
          permission: `${MEMBER_MANAGEMENT_DEADLINES_create}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "member-management-deadline-monitoring-deadline-new",
            });
          },
        },
      ],
      upcomingDueDates: [],
    };
  },
  computed: {
    deadlines() {
      const deadlines = this.$store.state.memberManagement.deadlines;
      return deadlines.map((deadline) => {
        return {
          ...deadline,
        };
      });
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "deadlines", data: this.deadlines }];
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getDeadlines();
      this.getUpcomingDeadlineEntries();
    },
    getDeadlines() {
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_DEADLINES}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    async getUpcomingDeadlineEntries() {
      try {
        const deadlineEntries = [];
        const now = new Date();
        const sixWeeksFromNow = new Date(now);
        sixWeeksFromNow.setDate(now.getDate() + 42);
        sixWeeksFromNow.setHours(0, 0, 0, 0);
        now.setHours(0, 0, 0, 0);

        const querySnapshot = await db
          .collection("organizations")
          .doc(this.$route.params.organizationId)
          .collection("deadlineEntries")
          .where("dueDate", ">=", Timestamp.fromDate(now))
          .where("dueDate", "<=", Timestamp.fromDate(sixWeeksFromNow))
          .get();

        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            deadlineEntries.push({ id: doc.id, ...doc.data() });
          });
        }
        this.upcomingDueDates = deadlineEntries;
      } catch (error) {
        console.error("Error querying documents:", error);
        throw error; // Re-throw the error for further handling
      }
    },

    getHeaderText(date) {
      return date;
    },
  },
};
</script>
